var map = {
	"./Anemuo.png": 139,
	"./Caterpie.png": 140,
	"./Gastly.png": 141,
	"./Kertruffle.png": 142,
	"./Koffing.png": 143,
	"./Larvabidae.png": 144,
	"./Mareep.png": 145,
	"./Musburry.png": 146,
	"./Peppit.png": 147,
	"./Pineco.png": 148,
	"./Poochyena.png": 149,
	"./Rattata-Alola.png": 150,
	"./Rattata.png": 151,
	"./Rockruff.png": 152,
	"./Rookidee.png": 153,
	"./Skullarva.png": 154,
	"./Skwovet.png": 155,
	"./Spearow.png": 156,
	"./Spinarak.png": 157,
	"./Spinda.png": 158,
	"./Turtwig.png": 159,
	"./UnownK.png": 160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 138;